import { Alert, Text, VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalEstabilizacaoV41() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 4.1.14' subtitle=' | 13/04/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Melhorias de desempenho no controle de sessões.</Text>
          <Text component='li'>Correção ao consultar os campos "Nome social" e "Estado" do CADWEB.</Text>
          <Text component='li'>
            Correção na contagem do bloco "Conduta/Desfecho" no relatório de produção de atendimentos odontológicos.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.1.13' subtitle=' | 26/03/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro onde ao registrar um aprazamento de vacina no grupo de Outros imunobiológicos uma caixa de
            mensagem era aberta sem nenhuma informação.
          </Text>
          <Text component='li'>
            Ajustes no módulo de Importar cidadão, onde cidadãos sem o nome do pai ou a marcação de desconhecer nome do
            pai não estavam sendo importados.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.1.12' subtitle=' | 03/03/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Otimização nas conexões utilizadas para requisições no CADWEB.</Text>
          <Text component='li'>Melhorias de performance na impressão dos relatórios.</Text>
          <Text component='li'>
            Correção de erro no filtro de atendimentos finalizados quando é o único filtro selecionado.
          </Text>
          <Text component='li'>
            Para agilizar o processo de cadastro de um novo cidadão, agora o botão de "Adicionar cidadão" será
            apresentado logo após a busca na base local ser finalizada, não necessitando aguardar a execução da busca na
            base nacional.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.1.10' subtitle=' | 22/02/2021'>
        <VFlow vSpacing={0.5}>
          <Alert type='warning'>
            Lotes de imunobiológicos de Covid-19 cadastrados com o nome do fabricante incorretamente ou incompleto foram
            desativados nesta versão. Se isso ocorreu, é necessário recadastrar os lotes desativados. A partir da versão
            atual, os lotes de imunobiológicos de Covid-19 cadastrados no sistema terão o campo fabricante preenchido
            automaticamente.
          </Alert>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
